import { render, staticRenderFns } from "./ExpertLeaderboard.vue?vue&type=template&id=07db60b3"
import script from "./ExpertLeaderboard.vue?vue&type=script&lang=js"
export * from "./ExpertLeaderboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports